import React, { useEffect, useRef, useState } from "react";
import { Button, Grid, TextField, MenuItem, Checkbox, FormGroup, FormControlLabel} from '@mui/material'
import { DatePicker } from '@mui/lab';
import GridBreak from '../../../components/GridBreak'
import IFramePopUp from '../../../components/Pop_ups/IFramePopUp';
import DragFiles from "../../../components/FileManagement/DragFiles";
import { fileTo64Arr, handleFormNumbers } from "../../../util/generalHelp";
import { createOfferDraft, removeOfferDraft, submitDraft, getFieldClause } from "../../../util/offerLettersHelp"; //getfieldclause should theoretically work w new stuff in configs, but we'll see
import { previewDocusign } from "../../../util/docusignHelper";
import { useBeforeunload } from 'react-beforeunload';
import { useBackListener } from "../../../util/Hooks";
import moment from "moment";
import { getProfileFromEmail } from "../../../util/ProfileHelper";

const OPTIONAL_FIELDS = ["address"]

// page 1 paragraphs of the US offer letter; always editable, independent of the employment contract addendum
const BODY_SECTIONS = [
    { key: 'intro', label: 'Introduction' },
    { key: 'compensation_benefits', label: 'Compensation and Benefits' },
    { key: 'contingencies', label: 'Contingencies' }
]

//Based on the original OfferForm.js + MasterOfServicesUSA.js; OfferLetterCAN.js functions similarly
function OfferLetterUSA(props){

    const defaultObj = {
        document_args: { //taken from originalOfferForms.js
            "job_title": "",
            paid_holidays: 0,
            vacation_days: 0, 
            sick_days: 0,
            salary: 0,
            pay_type: "SALARY",
            city: "",
            state: "",
            zip_code: "",
            start_date: moment().format('YYYY-MM-DD'),
            due_date: moment().format('YYYY-MM-DD')
        },
        benefits: true,
        showContractAddendum: false,
        region: 'USA',
        first_name: "",
        last_name: "",
        email_address: "",
        signatory: "",
        authority_id: null,
        "return_url": window.location.origin.toString(),
        venue_id: "",
        state_id: ""
    }

    const defaultFieldsOfferLetter = {
        benefits_included: false,
        scope_employee_duties: false,
        SEQ_duties: false,
        legal_work_auth: false,
        placement_term: false,
        intellectual_property: false,
        non_competition_employee: false,
        injunctive_relief_divisibility: false,
        heading: true,
        entire_agreement: true,
        governing: true,
        notices: true,
        pay_frequency: false,
        customOfferLetter: false,
    }

    const handleVacationDaysToggle = (e) => {
        const isChecked = e.target.checked;
        setShowVacationDays(isChecked);

        if (!isChecked) {
            // Reuse handleNumberForm's event-shaped input so it goes through
            // the same validation/state-update path as manual entry
            handleNumberForm(
                { target: { value: 0 }, preventDefault: () => {} },
                'vacation_days',
                true
            );
            }
    };

    const handleSickDaysToggle = (e) => {
        const isChecked = e.target.checked;
        setShowSickDays(isChecked);

        if (!isChecked) {
            handleNumberForm(
                { target: { value: 0 }, preventDefault: () => {} },
                'sick_days',
                true
            );
        }
    };

    const handlePaidHolidaysToggle = (e) => {
        const isChecked = e.target.checked;
        setShowPaidHolidays(isChecked);

        if (!isChecked) {
            handleNumberForm(
                { target: { value: 0 }, preventDefault: () => {} },
                'paid_holidays',
                true
            );
        }
    };

    // clause checkboxes that are only shown while "Add Employment Contract" is checked
    const CONTRACT_CLAUSES = ['scope_employee_duties', 'SEQ_duties', 'legal_work_auth', 'placement_term',
        'intellectual_property', 'non_competition_employee', 'injunctive_relief_divisibility', 'customOfferLetter', 'customOfferLetterHeader']

    const handleContractAddendumToggle = (e) => {
        const isChecked = e.target.checked;
        setShowContractAddendum(isChecked);
        setRequestObj({
            ...requestObj,
            showContractAddendum: isChecked
        })

        // the wording of some sections depends on the template; swap any section still on the old template's default
        if (bodyDefaults) {
            const from = bodyDefaults[isChecked ? "OfferLetterNoAddendum" : "OfferLetterAddendum"]
            const to = bodyDefaults[isChecked ? "OfferLetterAddendum" : "OfferLetterNoAddendum"]
            setBodySections(prev => {
                let next = {...prev}
                for (const { key } of BODY_SECTIONS) {
                    if (prev[key] === from[key]) next[key] = to[key]
                }
                return next
            })
        }

        // unchecking hides the clauses, so drop any selections/edits so they aren't sent with the offer
        if (!isChecked) {
            let newFieldsOfferLetter = {...fieldsOfferLetter}
            let newShowEdits = {...showEditClause}
            let newDefaultOfferText = {...defaultOfferText}
            for (const key of CONTRACT_CLAUSES) {
                if (key in newFieldsOfferLetter) newFieldsOfferLetter[key] = false
                delete newShowEdits[key]
                delete newDefaultOfferText[key]
            }
            setFieldsOfferLetter(newFieldsOfferLetter)
            setShowEditClause(newShowEdits)
            setDefaultOfferText(newDefaultOfferText)
        }
    };

    const changeFieldsOfferLetter = function (field, optfield = null, value){
        let newFieldsOfferLetter = {...fieldsOfferLetter}
        if (!value){
            console.log("!value, changefieldsofferletter")
            const keyClause = field
            const keyClause2 = optfield
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false

            if (keyClause2) {
                newShowEdits[keyClause2] = false
            }

            setShowEditClause(newShowEdits)
            let newDefaultOfferText = {...defaultOfferText}
            delete newDefaultOfferText[keyClause]
            
            if (keyClause2){
                delete newDefaultOfferText[keyClause2]
            }

            //header isn't deleted ^ because it's under customHeader, not customLetter
            //idea: set it to be like customLetter = [header, clause] ?
            //how to do that though...
            //otherwise add specific condition here to check + delete...react complained last time though
            setDefaultOfferText(newDefaultOfferText)
        }
        newFieldsOfferLetter[field] = value
        setFieldsOfferLetter(newFieldsOfferLetter)
    }

    const handleDefaultClause = function (keyClause, offer, checked)
    {
        props.setLoading(true)
        if (checked)
        {
            if (!defaultOfferText[keyClause])
                getFieldClause(keyClause, offer, 'usa_offer_document', (json) =>
            {
                if (json)
                {
                    let newDefaultOfferText = {...defaultOfferText}
                    newDefaultOfferText[keyClause] = json.clauses
                    setDefaultOfferText(newDefaultOfferText)
                    let newShowEdits = {...showEditClause}
                    newShowEdits[keyClause] = true
                    setShowEditClause(newShowEdits)
                }
                else{
                    props.setError("The requested clause text could not be fetched. This is usually due to server error.")
                }
                props.setLoading(false)
            })
            else
            {
                let newShowEdits = {...showEditClause}
                newShowEdits[keyClause] = true
                setShowEditClause(newShowEdits)
                props.setLoading(false)
            }
        }
        else
        {
            let newShowEdits = {...showEditClause}
            newShowEdits[keyClause] = false
            setShowEditClause(newShowEdits)
            let newDefaultOfferText = {...defaultOfferText}
            delete newDefaultOfferText[keyClause]
            setDefaultOfferText(newDefaultOfferText)
            props.setLoading(false)
        }   
    }

    // blank form used after an offer is sent; region/return_url/benefits are not user inputs so they are kept.
    // day counts stay 0 because their inputs are hidden until toggled on and the backend requires them
    const emptyObj = () => ({
        document_args: {
            job_title: null,
            paid_holidays: 0,
            vacation_days: 0,
            sick_days: 0,
            salary: null,
            pay_type: null,
            address: null,
            city: null,
            state: null,
            zip_code: null,
            start_date: null,
            due_date: null
        },
        benefits: true,
        showContractAddendum: false,
        region: 'USA',
        first_name: null,
        last_name: null,
        email_address: null,
        signatory: null,
        authority_id: null,
        recruiter: null,
        account_manager: null,
        client_id: null,
        contact_id: null,
        "return_url": window.location.origin.toString(),
        venue_id: null,
        state_id: null
    })

    // state to start the form with when a previous offer letter is loaded (see ManageOffers); null for a blank form
    const buildLoadedForm = () => {
        if (!props.loadedOffer) return null
        const { offer, form } = props.loadedOffer
        if (form) {
            const { body_sections, ...savedObj } = form.request_obj
            const defaultChanges = form.default_changes || {}
            return {
                requestObj: { ...defaultObj, ...savedObj, return_url: defaultObj.return_url,
                    document_args: { ...defaultObj.document_args, ...savedObj.document_args } },
                bodySections: body_sections || {},
                fieldsOfferLetter: { ...defaultFieldsOfferLetter, ...form.fieldsOfferLetter },
                defaultOfferText: defaultChanges,
                showEditClause: Object.fromEntries(Object.keys(defaultChanges).map((key) => [key, true]))
            }
        }
        // offer letters drafted before the whole form was saved only have what is stored on the envelope
        const [firstName, ...lastName] = offer.name.split(' ')
        const authority = props.authorities.find((auth) => auth.id === offer.authority_id)
        return {
            requestObj: { ...defaultObj, first_name: firstName, last_name: lastName.join(' '), email_address: offer.email_address,
                authority_id: offer.authority_id, contact_id: offer.contact_id ?? '',
                document_args: { ...defaultObj.document_args, auth_name: authority?.name || '' } },
            bodySections: {},
            fieldsOfferLetter: { ...defaultFieldsOfferLetter },
            defaultOfferText: {},
            showEditClause: {}
        }
    }
    const [loaded] = useState(buildLoadedForm)

    const [requestObj, setRequestObj] = useState(loaded ? loaded.requestObj : { ...defaultObj })
    const [formKey, setFormKey] = useState(0)
    const [previewUrl, setPreviewUrl] = useState()
    const [previewClicked, setPreviewClicked] = useState(false)
    const [envelopeId, setEnvelopeId] = useState("")
    const [fileArr, setFileArr] = useState([])
    const [uploadStatus, setUploadStatus] = useState('error')
    const [fieldsOfferLetter, setFieldsOfferLetter] = useState(loaded ? loaded.fieldsOfferLetter : { ...defaultFieldsOfferLetter })
    const [defaultOfferText, setDefaultOfferText] = useState(loaded ? loaded.defaultOfferText : {})
    const [showEditClause, setShowEditClause] = useState(loaded ? loaded.showEditClause : {})
    const [showVacationDays, setShowVacationDays] = useState(Number(requestObj.document_args.vacation_days) > 0);
    const [showSickDays, setShowSickDays] = useState(Number(requestObj.document_args.sick_days) > 0);
    const [showPaidHolidays, setShowPaidHolidays] = useState(Number(requestObj.document_args.paid_holidays) > 0);
    const [showContractAddendum, setShowContractAddendum] = useState(Boolean(requestObj.showContractAddendum))
    const [showAddress, setShowAddress] = useState(Boolean(requestObj.document_args.address))
    // text for the page 1 body sections, keyed by section; these sections are required, so they are always shown and editable
    const [bodySections, setBodySections] = useState(loaded ? loaded.bodySections : {})
    // default wording of each section for both templates: { OfferLetterAddendum: {...}, OfferLetterNoAddendum: {...} }
    const [bodyDefaults, setBodyDefaults] = useState(null)

    useEffect(() => {
        const templates = ["OfferLetterAddendum", "OfferLetterNoAddendum"]
        const fetchSection = (key, template) => new Promise((resolve) =>
            getFieldClause(key, template, 'usa_offer_document', (json) => resolve(json && json.clauses ? json.clauses[0] : null)))
        const requests = templates.flatMap((template) => BODY_SECTIONS.map(({ key }) => ({ template, key })))
        Promise.all(requests.map(({ key, template }) => fetchSection(key, template))).then((texts) => {
            let defaults = { OfferLetterAddendum: {}, OfferLetterNoAddendum: {} }
            requests.forEach(({ template, key }, i) => { if (texts[i] !== null) defaults[template][key] = texts[i] })
            if (texts.includes(null)) {
                props.setError("The default letter section text could not be fetched. This is usually due to server error.")
            }
            setBodyDefaults(defaults)
            // sections from a loaded offer letter keep their saved text
            setBodySections(prev => ({ ...defaults[showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum"], ...prev }))
        })
    // load the defaults once on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // void the open draft if the form goes away with one (e.g. another offer letter is loaded or the country is switched)
    const draftId = useRef()
    draftId.current = requestObj.id
    useEffect(() => () => {
        if (draftId.current){
            removeOfferDraft(draftId.current, (resp) => { }, true)
        }
    }, [])


    useEffect(() => {
    }, [showEditClause])

    useEffect(() => {
            if (fieldsOfferLetter.benefits_included){
                let newObj = {...requestObj}
                newObj['document_args']['benefits_included'] = true
                setRequestObj(newObj)
            }
            else{
                let newObj = {...requestObj}
                delete newObj['document_args']['benefits_included']
                setRequestObj(newObj)
            }
    }, [fieldsOfferLetter.benefits_included])

    useEffect(() => {
        if (fileArr && fileArr.length > 0){
            setUploadStatus('success')
        }
        else {
            setUploadStatus('pending')
        }
    }, [fileArr])

    useBackListener(({location}) => {
        if (requestObj.id){
            removeOfferDraft(requestObj.id, (resp)=>{ }, true) //comes from offerlettershelp
        }
    })

    useBeforeunload((event) => {
        if (requestObj.id){
            removeOfferDraft(requestObj.id, (resp) => { }, true) //comes from offerlettershelp
        }
    });

    const closePreview = () => {
        setPreviewClicked(false)
        previewDocusign(envelopeId, (json) => {
            if (json) {
                setPreviewUrl(json.redirect_url)
            }
        })
    }

    const updateDocument = (key, value) => {
        let newDoc = {...requestObj}
        if (key == 'seq_hire_helper') {
                newDoc['document_args']['seq_hire_statement'] = defaultObj.document_args.seq_hire_statement.replace(/X/, `${value}`)
            }
        newDoc['document_args'][key] = value
        setRequestObj(newDoc)
    }

    const handleDraft = async () => {

        if (previewUrl && requestObj.id){
            props.setLoading(true)
            submitDraft(requestObj.id, envelopeId, (resp) => {
                if (resp){
                    setRequestObj(emptyObj())
                    setFileArr([])
                    setPreviewUrl()
                    setEnvelopeId("")
                    setFieldsOfferLetter({ ...defaultFieldsOfferLetter })
                    setDefaultOfferText({})
                    setShowEditClause({})
                    setShowVacationDays(false)
                    setShowSickDays(false)
                    setShowPaidHolidays(false)
                    setShowContractAddendum(false)
                    setShowAddress(false)
                    setBodySections(bodyDefaults ? { ...bodyDefaults.OfferLetterNoAddendum } : {})
                    setFormKey(formKey + 1) // remounts DragFiles so its internal file list is cleared
                    if (props.onComplete){
                        props.onComplete()
                    }
                } else {
                    props.onError({})
                }
                props.setLoading(false)
        })

        } else {
            props.setLoading(true)
            setPreviewUrl()
            if (checkJson(requestObj)){
                getProfileFromEmail(async (profile) =>
                {
                let request_obj = {...requestObj}
                // the street name is optional, and the backend rejects empty document_args, so leave it out when blank
                request_obj.document_args = {...requestObj.document_args}
                if (!request_obj.document_args.address) {
                    delete request_obj.document_args.address
                }
                request_obj.document_b64s = await handleFile(fileArr)
                request_obj.body_sections = bodySections
                const jsonSend = {request_obj: request_obj, optional_fields: OPTIONAL_FIELDS, contract: 'OfferLetter', fields: ['fieldsOfferLetter'], fieldsOfferLetter: fieldsOfferLetter, default_changes: defaultOfferText, sender: profile.id}
                createOfferDraft(jsonSend, (resp) => {
                    if (resp) {
                        updateOffer('id', resp.id)
                        setPreviewUrl(resp.redirect_url)
                        setUploadStatus('disabled')
                        setEnvelopeId(resp.envelope_id)
                    } else {
                        props.onError({})
                    }
                    props.setLoading(false)
                })
            })
            } else {
                props.onError({ errorTitle: 'Missing Form Fields', errorContent: "Please fill out all available form fields" })
                props.setLoading(false)
            }
        }
    }

    const checkJson = (json) => {
        for (const key of Object.keys(json)){
            if (json[key] === null || json[key] === undefined || json[key] === ''){
                if (!props.optionalFields.includes(key))
                    return false
            }

            if (json[key] != null && json[key].constructor == Object){
                if (!checkJson(json[key])){
                    return false
                }
                continue
            }
        }
        return true
    }

    const handleAuthorityChange = (e) => {
        const selectedId = e.target.value;
        const selectedAuthority = props.authorities.find((auth) => auth.id === selectedId);

        setRequestObj(prev => ({
            ...prev,
            authority_id: selectedId,
            document_args: {
                ...prev.document_args,
                auth_name: selectedAuthority?.name || ''
            }
        }));
    };

    const handleAddressToggle = (e) => {
        const isChecked = e.target.checked;
        setShowAddress(isChecked);

        if (!isChecked) {
            updateDocument('address', '');
        }
    };

    const updateOffer = (key, value, del = false) => {
        let newOffer = {...requestObj}
        if (!del){
            newOffer[key] = value
            setRequestObj(newOffer)
        }
        else {
            delete newOffer[key]
            setRequestObj(newOffer)
        }
    }

    const handleClear = () => {
        if (requestObj.id){
            props.setLoading(true)
            removeOfferDraft(requestObj.id, (resp) => {
                if (resp) {
                    let newOffer = {...requestObj}
                    delete newOffer['id']
                    setRequestObj(newOffer)
                    setPreviewUrl()
                    setUploadStatus('pending')
                }
                else {
                    props.onError({})
                }
                props.setLoading(false)
            })
        }
    }

    const handleFile = async (fileArr) => {
        return await fileTo64Arr(fileArr)
    }

    const handleNumberForm = (e, key, document = false, decimals = 0, maxdigits = undefined) => {
        let modfiedNum = handleFormNumbers(e.target.value, decimals, false, maxdigits)
        if (modfiedNum !== undefined) {
            if (document) {
                updateDocument(key, modfiedNum)
            } else {
                updateOffer(key, modfiedNum)
            }
        }
    }

    const changeDefaultText = function (key, value, index, length){
        let newDefault = {...defaultOfferText}
        if (index !== undefined && newDefault[key] !== undefined){
            newDefault[key][index] = value
        }
        else if (index !== undefined){
            newDefault[key] = Array(length)
            let i = 0
            while (i < length){
                newDefault[key][i] = defaultOfferText[key][i]
                i++
            }
            newDefault[key][index] = value
        }
        else
            newDefault[key] = value
        setDefaultOfferText(newDefault)
    }

    return (
    <>
        <Grid container spacing={2} sx={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row', width: '100%', padding: '1%' }}>
        <IFramePopUp open={previewClicked} url={previewUrl} onClose={closePreview} maxRedirect={2} />
            <FormGroup item sx={{ width: '100%', padding: '1%'}}>
                {BODY_SECTIONS.map(({ key, label }) => (
                    <React.Fragment key={key}>
                        {/* required section: always selected and can't be unchecked, but its text stays editable */}
                        <FormControlLabel control={<Checkbox checked disabled />} label={`Edit ${label}`} />
                        {key in bodySections ?
                            <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                                <TextField sx = {{'margin': '1%'}} label={`Current ${label} Text`} disabled={Boolean(previewUrl)}
                                    helperText="Words in {braces} such as {job_title} are filled in automatically"
                                    value={bodySections[key] ?? ''}
                                    onChange={(e) => setBodySections({...bodySections, [key]: e.target.value})}
                                    fullWidth required multiline />
                            </Grid> : <></>
                        }
                    </React.Fragment>
                ))}
            </FormGroup>
            {showContractAddendum ?
            <FormGroup item sx={{ width: '100%', padding: '1%'}}>
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.scope_employee_duties} onChange = {(e) => changeFieldsOfferLetter("scope_employee_duties", null, e.target.checked)} />} label={"Scope of Employee's Duties"} />
                {fieldsOfferLetter.scope_employee_duties ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.scope_employee_duties}
                            onChange = {(e) => handleDefaultClause("scope_employee_duties", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Scope of Employee's Duties Clause"} />
                        {showEditClause.scope_employee_duties ?
                        <TextField sx = {{'margin': '1%'}} label="Current Scope of Employee's Duties Clause"
                            value={defaultOfferText.scope_employee_duties ?? ''}
                            onChange = {(e) => changeDefaultText("scope_employee_duties", e.target.value)}
                            fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.SEQ_duties} onChange = {(e) => changeFieldsOfferLetter("SEQ_duties", null, e.target.checked)} />} label={"Duties of SEQ"} />
                    {fieldsOfferLetter.SEQ_duties ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.SEQ_duties}
                            onChange = {(e) => handleDefaultClause("SEQ_duties", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Duties of SEQ Clause"} />
                        {showEditClause.SEQ_duties ?
                        <TextField sx = {{'margin': '1%'}} label="Current Duties of SEQ Clause"
                            value={defaultOfferText.SEQ_duties ?? ''}
                                onChange = {(e) => changeDefaultText("SEQ_duties", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.legal_work_auth} onChange = {(e) => changeFieldsOfferLetter("legal_work_auth", null, e.target.checked)} />} label={"Legal Work Authorization"} />
                {fieldsOfferLetter.legal_work_auth ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.legal_work_auth}
                            onChange = {(e) => handleDefaultClause("legal_work_auth", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Legal Work Authorization Clause"} />
                        {showEditClause.legal_work_auth ?
                        <TextField sx = {{'margin': '1%'}} label="Current Legal Work Authorization Clause"
                            value={defaultOfferText.legal_work_auth ?? ''}
                                onChange = {(e) => changeDefaultText("legal_work_auth", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.placement_term} onChange = {(e) => changeFieldsOfferLetter("placement_term", null, e.target.checked)} />} label={"Term of Placement"} />
                {fieldsOfferLetter.placement_term ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.placement_term}
                            onChange = {(e) => handleDefaultClause("placement_term", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Term of Placement Clause"} />
                        {showEditClause.placement_term ?
                        <TextField sx = {{'margin': '1%'}} label="Current Term of Placement Clause"
                            value={defaultOfferText.placement_term ?? ''}
                                onChange = {(e) => changeDefaultText("placement_term", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.intellectual_property} onChange = {(e) => changeFieldsOfferLetter("intellectual_property", null, e.target.checked)} />} label={"Intellectual Property"} />
                {fieldsOfferLetter.intellectual_property ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.intellectual_property}
                            onChange = {(e) => handleDefaultClause("intellectual_property", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Intellectual Property Clause"} />
                        {showEditClause.intellectual_property ?
                        <TextField sx = {{'margin': '1%'}} label="Current Intellectual Property Clause"
                            value={defaultOfferText.intellectual_property ?? ''}
                                onChange = {(e) => changeDefaultText("intellectual_property", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.non_competition_employee} onChange = {(e) => changeFieldsOfferLetter("non_competition_employee", null, e.target.checked)} />} label={"Non-competition by the Employee"} />
                {fieldsOfferLetter.non_competition_employee ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.non_competition_employee}
                            onChange = {(e) => handleDefaultClause("non_competition_employee", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Non-competition by the Employee Clause"} />
                        {showEditClause.non_competition_employee ?
                        <TextField sx = {{'margin': '1%'}} label="Current Non-competition by the Employee Clause"
                            value={defaultOfferText.non_competition_employee ?? ''}
                                onChange = {(e) => changeDefaultText("non_competition_employee", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={<Checkbox checked = {fieldsOfferLetter.injunctive_relief_divisibility} onChange = {(e) => changeFieldsOfferLetter("injunctive_relief_divisibility", null, e.target.checked)} />} label={"Injunctive Relief, Divisibility, Partial Invalidity"} />
                {fieldsOfferLetter.injunctive_relief_divisibility ? 
                    <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                        <FormControlLabel control = {<Checkbox checked = {showEditClause.injunctive_relief_divisibility}
                            onChange = {(e) => handleDefaultClause("injunctive_relief_divisibility", showContractAddendum ? "OfferLetterAddendum" : "OfferLetterNoAddendum", e.target.checked)} /> }
                            label = {"Edit Injunctive Relief, Divisibility, Partial Invalidity Clause"} />
                        {showEditClause.injunctive_relief_divisibility ?
                        <TextField sx = {{'margin': '1%'}} label="Current Injunctive Relief, Divisibility, Partial Invalidity Clause"
                            value={defaultOfferText.injunctive_relief_divisibility ?? ''}
                                onChange = {(e) => changeDefaultText("injunctive_relief_divisibility", e.target.value)}
                                fullWidth required multiline /> : <></>
                        }
                    </Grid> : <></>
                }
                <FormControlLabel control={ <Checkbox checked = {fieldsOfferLetter.customOfferLetter} onChange = {(e) => changeFieldsOfferLetter("customOfferLetter", "customOfferLetterHeader", e.target.checked)} /> } label = {"Add a Custom Field"} />
                {fieldsOfferLetter.customOfferLetter ?
                        <Grid sx = {{'margin-left': '10%', 'width': '75%'}}>
                            <TextField sx = {{'margin': '1%'}} label="Current Custom Header"
                                value={defaultOfferText.customOfferLetterHeader ?? ''} onChange= {(e) => changeDefaultText("customOfferLetterHeader", e.target.value)} fullWidth required />
                            <TextField sx = {{'margin': '1%'}} label="Current Custom Clause"
                                value={defaultOfferText.customOfferLetter ?? ''} onChange= {(e) => changeDefaultText("customOfferLetter", e.target.value)} fullWidth required multiline />
                        </Grid>
                            : <></>
                }
            </FormGroup> : <></>
            }
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="First Name" onChange={(e) => { e.preventDefault(); updateOffer('first_name', e.target.value) }}
                    value={requestObj.first_name ?? ''} fullWidth required />
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="Last Name" onChange={(e) => { e.preventDefault(); updateOffer('last_name', e.target.value) }}
                    value={requestObj.last_name ?? ''} fullWidth required />
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="Email Address" onChange={(e) => { e.preventDefault(); updateOffer('email_address', e.target.value) }}
                    value={requestObj.email_address ?? ''} fullWidth required />
            </Grid>

            <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showAddress}
                            onChange={handleAddressToggle}
                            disabled={Boolean(previewUrl)}
                        />
                    }
                    label="Include Street Name"
                />
            </Grid>
            {showAddress && (
                <Grid item xs={3}>
                    <TextField
                        disabled={Boolean(previewUrl)}
                        label="Street Name"
                        onChange={(e) => { e.preventDefault(); updateDocument('address', e.target.value) }}
                        value={requestObj.document_args.address ?? ''}
                        fullWidth
                    />
                </Grid>
            )}
            
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="City" onChange={(e) => { e.preventDefault(); updateDocument('city', e.target.value) }}
                    value={requestObj.document_args.city ?? ''} fullWidth required />
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="State" onChange={(e) => { e.preventDefault(); updateDocument('state', e.target.value) }}
                    value={requestObj.document_args.state ?? ''} fullWidth required />
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="Zip Code" onChange={(e) => { e.preventDefault(); updateDocument('zip_code', e.target.value) }}
                    value={requestObj.document_args.zip_code ?? ''} fullWidth required />
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} label="Job Title" onChange={(e) => { e.preventDefault(); updateDocument('job_title', e.target.value) }}
                    value={requestObj.document_args.job_title ?? ''} fullWidth required />
            </Grid>

            <Grid item xs={3}>
                <TextField
                    disabled={Boolean(previewUrl)}
                    required
                    label="Pay Type"
                    onChange={(e) => { e.preventDefault(); updateDocument('pay_type', e.target.value) }}
                    value={requestObj.document_args.pay_type ?? ''}
                    fullWidth
                    select
                >
                    <MenuItem value="HOURLY">Hourly</MenuItem>
                    <MenuItem value="SALARY">Salary</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs={3}>
                {requestObj.document_args.pay_type === 'SALARY' ?
                    <TextField disabled={Boolean(previewUrl)} label="Salary ($)" SelectProps='0.01' onChange={(e) => {
                        e.preventDefault();
                        handleNumberForm(e, 'salary', true, 2)
                    }}
                        value={requestObj.document_args.salary ?? ''} fullWidth required /> :
                    <TextField disabled={Boolean(previewUrl)} label="Hourly Rate ($/hr)" SelectProps='0.01' onChange={(e) => {
                        e.preventDefault();
                        handleNumberForm(e, 'salary', true, 2)
                    }}
                        value={requestObj.document_args.salary ?? ''} fullWidth required />
                }
            </Grid>
            <Grid item xs={3}>
            <DatePicker disabled={Boolean(previewUrl)} label="Start Date" value={requestObj.document_args.start_date}
            selected={""}
                onChange={(value) => updateDocument('start_date', value.format('YYYY-MM-DD').toString())}
                renderInput={(params) => <TextField required fullWidth {...params} />}
                minDate={requestObj.document_args.due_date ? moment.max(moment(), moment(requestObj.document_args.due_date)) : moment()}
                />
            </Grid>
            <Grid item xs={3}>
            <DatePicker disabled={Boolean(previewUrl)} label="Due Date" value={requestObj.document_args.due_date}
                onChange={(value) => updateDocument('due_date', value.format('YYYY-MM-DD').toString())}
                renderInput={(params) => <TextField required fullWidth {...params} />} minDate={moment.utc()}
                maxDate={moment(requestObj.document_args.start_date ?? undefined)}/>
            </Grid>
            <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showVacationDays}
                            onChange={handleVacationDaysToggle}
                            disabled={Boolean(previewUrl)}
                        />
                    }
                    label="Include Vacation Days"
                />
            </Grid>

            {showVacationDays && (
                <Grid item xs={3}>
                    <TextField
                        disabled={Boolean(previewUrl)}
                        label="Vacation Days"
                        onChange={(e) => { e.preventDefault(); handleNumberForm(e, 'vacation_days', true); }}
                        value={requestObj.document_args.vacation_days ?? ''}
                        fullWidth
                        required
                    >
                    </TextField>
                </Grid>
            )}
            <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showSickDays}
                            onChange={handleSickDaysToggle}
                            disabled={Boolean(previewUrl)}
                        />
                    }
                    label="Include Sick Days"
                />
            </Grid>
            {showSickDays && (
                <Grid item xs={3}>
                    <TextField
                        disabled={Boolean(previewUrl)}
                        label="Sick Days"
                        onChange={(e) => { e.preventDefault(); handleNumberForm(e, 'sick_days', true); }}
                        value={requestObj.document_args.sick_days ?? ''}
                        fullWidth
                        required
                    >
                    </TextField>
                </Grid>
            )}

            <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showPaidHolidays}
                            onChange={handlePaidHolidaysToggle}
                            disabled={Boolean(previewUrl)}
                        />
                    }
                    label="Include Paid Holidays"
                />
            </Grid>

            {showPaidHolidays && (
                <Grid item xs={3}>
                    <TextField
                        disabled={Boolean(previewUrl)}
                        label="Paid Holidays"
                        onChange={(e) => { e.preventDefault(); handleNumberForm(e, 'paid_holidays', true); }}
                        value={requestObj.document_args.paid_holidays ?? ''}
                        fullWidth
                        required
                    >
                    </TextField>
                </Grid>
            )}

            <Grid item xs={3}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={showContractAddendum}
                            onChange={handleContractAddendumToggle}
                            disabled={Boolean(previewUrl)}
                        />
                    }
                    label="Add Employment Contract"
                />
            </Grid>

            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} required label="Approver" onChange={handleAuthorityChange}
                    value={requestObj.authority_id ?? ''} fullWidth select>
                    {props.authorities.map((auth) => (
                        <MenuItem key={auth.id} value={auth.id}>
                            {auth.name}({auth.email_address})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={3}>
                <TextField
                    disabled={Boolean(previewUrl)}
                    required
                    label="Recruiter"
                    onChange={(e) => updateOffer('recruiter', e.target.value)}
                    value={requestObj.recruiter || ''}
                    fullWidth
                    select
                >
                    {props.recruiters.map((r) => (
                        <MenuItem key={r.id} value={r.id}>
                            {r.first_name} {r.last_name} ({r.email})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={3}>
                <TextField
                    disabled={Boolean(previewUrl)}
                    required
                    label="Account Manager"
                    onChange={(e) => updateOffer('account_manager', e.target.value)}
                    value={requestObj.account_manager || ''}
                    fullWidth
                    select
                >
                    {props.accountManagers.map((r) => (
                        <MenuItem key={r.id} value={r.id}>
                            {r.first_name} {r.last_name} ({r.email})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>

            <Grid item xs={3}>
                <TextField
                    disabled={Boolean(previewUrl)}
                    required
                    label="Signatory"
                    onChange={(e) => updateOffer('signatory', e.target.value)}
                    value={requestObj.signatory || ''}
                    fullWidth
                    select
                >
                    {props.signatories.map((r) => (
                        <MenuItem key={r.id} value={r.id}>
                            {r.first_name} {r.last_name} ({r.email})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>


            <Grid item xs={3}>
                <TextField label="Client" required={true} disabled={previewUrl} onChange={(e) => { e.preventDefault(); updateOffer('client_id', e.target.value) }}
                    value={requestObj.client_id ?? ''} fullWidth select>
                    {props.clients.map((auth) => (
                        <MenuItem key={auth.id} value={auth.id}>
                            {auth.short_name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl)} required label="Contacts" onChange={(e) => { e.preventDefault(); updateOffer('contact_id', e.target.value) }}
                    value={requestObj.contact_id ?? ''} fullWidth select>
                    {props.contacts.map((auth) => (
                        <MenuItem key={auth.id} value={auth.id}>
                            {auth.name}({auth.email_address})
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
            <TextField disabled={Boolean(previewUrl)} required label="State"
                    onChange={(e) => { e.preventDefault(); updateOffer('state_id', e.target.value) }}
                    value={requestObj.state_id ?? ''} fullWidth select>
                    {props.states.map((auth) => (
                        <MenuItem key={auth.id} value={auth.id}>
                            {auth.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={3}>
                <TextField disabled={Boolean(previewUrl) || !requestObj.state_id} required label="Venue"
                    onChange={(e) => { e.preventDefault(); updateOffer('venue_id', e.target.value) }}
                    value={requestObj.venue_id ?? ''} fullWidth select>
                    {props.venues.filter(v => v.type === requestObj.state_id).map((auth) => (
                        <MenuItem key={auth.id} value={auth.id}>
                            {auth.name}
                        </MenuItem>
                    ))}
                </TextField>
            </Grid>
        <GridBreak />
            <Grid item container xs={12} sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <DragFiles key={formKey} types={props.fileTypes} multiple={true} disabled={Boolean(previewUrl)} onUpdate={setFileArr}
                    maxSize={15}
                    onTypeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Type Error', errorContent: error }) }}
                    onSizeError={(error) => { setUploadStatus('error'); props.onError({ errorTitle: 'File Size Error', errorContent: error }) }}
                    uploadStatus={uploadStatus} />
            </Grid>
            <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); handleClear() }}>Cancel</Button>
            </Grid>
            <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Button fullWidth disabled={!previewUrl || !requestObj.id} onClick={(e) => { e.preventDefault(); setPreviewClicked(true) }}>Preview Document</Button>
            </Grid>
            <Grid item xs={4} container sx={{ justifyContent: 'center', alignItems: 'center' }}>
                <Button fullWidth onClick={(e) => { e.preventDefault(); handleDraft() }}>{requestObj.id && previewUrl ? "Send" : "Create Draft"}</Button>
            </Grid>
    </Grid>
    </>);
}

export default OfferLetterUSA;